import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DictionarySapSymbolsDataService } from 'src/app/shared';
import { ErrorDialogComponent } from 'src/components/shared/error-dialog/error-dialog.component';

@Component({
  standalone: false,
  selector: 'app-add-new-sap-symbols-dialog',
  templateUrl: './add-new-sap-symbols-dialog.component.html',
  styleUrl: './add-new-sap-symbols-dialog.component.scss',
})
export class AddNewSapSymbolsDialogComponent {
  newSymbolForm: FormGroup;
  errorMessage?: string;

  indexTypes = [
    '',
    'Daily',
    'Weekly (MON)',
    'Weekly (TUE)',
    'BiWeekly',
    'Monthly',
    'Other'
  ];
  constructor(
    public dialogRef: MatDialogRef<AddNewSapSymbolsDialogComponent>,
    private dataService: DictionarySapSymbolsDataService,
    private dialog: MatDialog
  ) {
    this.newSymbolForm = new FormGroup({
      symbol: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('^[a-zA-Z0-9/_ -]{1,50}$')
        ],
      }),
      indexName: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('^[a-zA-Z0-9/ ]{1,50}$'),
        ],
      }),
      indexType: new FormControl('', {
        validators: [],
      })
    })
  }

  transformToUppercase(field: string) {
    let currentValue = this.newSymbolForm.get(field)?.value;
    if (currentValue) {
      this.newSymbolForm.get(field)?.setValue(currentValue.toUpperCase(),
        { emitEvent: false });
    }
  }

  addNewSymbol() {
    const request = this.newSymbolForm.value;
    this.dataService.add(request).subscribe({
      next: () => {
        this.dialogRef.close(this.newSymbolForm.value);
      },
      error: (error) => {
        if (error || this.newSymbolForm.invalid) {
          console.error(error.error.Message);
          this.errorMessage = error.error.Message;
          this.handleError(error);
        }
      },
    });
  }

  private handleError(error: any) {
    this.dialog.open(ErrorDialogComponent, {
      data: { message: error.error.Message },
    });
  }
}
